<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('dictamen')"
      :columns="columns"
      :column_search="true"
      resource_url="/dictamen/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <dictamen-modal ref="dictamen_modal" @success="refresh" />
  <log-modal ref="log_modal" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  get,
  error_message,
  success_message,
  download,
  format_currency,
} from "@/utils";
import DictamenModal from "./dictamen_modal/Index.vue";
import LogModal from "./log_modal/Index.vue";
import moment from "moment";

export default {
  name: "DictamensDatatable",
  components: { GenericTable, DictamenModal, LogModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          searchable: false,
          data: (row) => {
            let r = `<div class="title is-6">${row.name}</div>`;
            if (row.dpi)
              r += `<div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-id-card"></i></span>DPI: <strong>${row.dpi}</strong></div>`;
            // if (row.promissory_note_number)
            //   r += `<div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-file"></i></span>${v.$t(
            //     "promissory note number"
            //   )}: <strong>${row.promissory_note_number}</strong></div>`;
            // if (row.nit)
            //   r += `<div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-id-card"></i></span>NIT: <strong>${
            //     row.nit || ""
            //   }</strong></div>`;
            return r;
            // return row.name || "";
          },
        },
        {
          title: v.$t("identificators"),
          searchable: false,
          data: (row) => {
            let r = ``;
            if (row.promissory_note_number)
              r += `<div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-file"></i></span>${v.$t(
                "promissory note number"
              )}: <strong>${row.promissory_note_number}</strong></div>`;
            if (row.nit)
              r += `<div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-id-card"></i></span>NIT: <strong>${
                row.nit || ""
              }</strong></div>`;
            if (row.settings && row.settings.report_date)
              r += `<div class="subtitle is-6 mb-0"><span class="icon"><i class="fa fa-calendar"></i></span>${v.$t(
                "report date"
              )}: <strong>${moment(row.settings.report_date).format(
                "DD/MM/YYYY"
              )}</strong></div>`;
            return r;
            // return row.name || "";
          },
        },
        // {
        //   title: v.$t("dpi"),
        //   searchable: false,
        //   data: (row) => {
        //     return row.dpi || "";
        //   },
        // },
        // {
        //   title: v.$t("promissory note number"),
        //   searchable: false,
        //   data: (row) => {
        //     return row.promissory_note_number || "";
        //   },
        // },
        {
          title: v.$t("process results"),
          searchable: false,
          data: (row) => {
            let r = "";
            if (row.extraction_result) {
              if (row.extraction_result.result == "ok")
                r += `<div class="tag is-black"><span class="icon has-text-success"><i class="fa fa-check"></i></span><span>${v.$t(
                  "data extracted"
                )}</span></div>`;
              else
                r += `<div class="tag is-black"><span class="icon has-text-danger"><i class="fa fa-times"></i></span><span>${v.$t(
                  "error getting data"
                )}</span></div>`;
            }

            if (row.report_result) {
              if (row.report_result.result == "ok")
                r += `<div class="tag is-black"><span class="icon has-text-success"><i class="fa fa-check"></i></span><span>${v.$t(
                  "report generated"
                )}</span></div>`;
              else
                r += `<div class="tag is-black"><span class="icon has-text-danger"><i class="fa fa-times"></i></span><span>${v.$t(
                  "error generating report"
                )}</span></div>`;
            }
            return r;
          },
        },
        // {
        //   title: v.$t("report generation result"),
        //   searchable: false,
        //   data: (row) => {
        //     if (row.report_result) {
        //       if (row.report_result.result == "ok")
        //         return `<span class="icon has-text-success"><i class="fa fa-check"></i></span><span>${v.$t(
        //           "report generated"
        //         )}</span>`;
        //       else
        //         return `<span class="icon has-text-danger"><i class="fa fa-times"></i></span><span>${v.$t(
        //           "error generating report"
        //         )}</span>`;
        //     } else return "";
        //   },
        // },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: false,
        //   width: "80%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            let btns = [
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("edit"),
              //   icon: "fa fa-edit",
              //   icon_class: "is-small",
              //   click: function (e) {
              //     // console.log("edit order", e.detail.uuid);
              //     v.$refs.dictamen_modal.edit_modal(e.detail.uuid);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete dictamen?"),
                    v,
                    () => {
                      del("/dictamen", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("start"),
                icon: "fa fa-bolt",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  success_message(v.$t("dictamen started, please wait..."));
                  post("/dictamen/start", { uuid: uuid })
                    .then((r) => {
                      success_message(v.$t(r));
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("start ws"),
                icon: "fa fa-bolt",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  success_message(v.$t("dictamen started, please wait..."));
                  v.$root.loader(true);
                  post("/dictamen/start-ws", { uuid: uuid })
                    .then((r) => {
                      success_message(v.$t(r));
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    })
                    .finally(() => {
                      v.$root.loader(false);
                    });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.log_modal.show_modal(e.detail.uuid);
                },
              },
            ];

            if (row.report_result && row.report_result.file_location) {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("download dictamen"),
                icon: "fa fa-download",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  let uuid = e.detail.uuid;

                  download(
                    `/dictamen/download?uuid=${e.detail.uuid}`,
                    `Dictamen ${row.name} ${moment().format(
                      "YYYYMMDDHHmmss"
                    )}.pdf`
                  )
                    .then(() => {
                      success_message(v.$t("download complete"));
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            }

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.dictamen_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
